import { skipToken } from "@reduxjs/toolkit/query";
import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { selectPickingStateArgs } from "~/redux/selectors/autostoreSelectors";
import autostorePickingApi from "~/redux/warehouse/autostorePicking";

// RTK Query throws when refetching a skipped query, which would abort the calling flow
// part way through whenever start-picking hasn't selected a batch yet.
// This can be considered technical debt and should be removed once refetching is no longer needed.
// Cache invalidation is the preferred mechanism for refreshing state.
export function useRefetchBatchPickingState() {
  const dispatch = useAppDispatch();
  const pickingStateArgs = useAppSelector(selectPickingStateArgs);

  return useCallback(async () => {
    if (pickingStateArgs === skipToken) return { data: undefined };

    return dispatch(
      autostorePickingApi.endpoints.getBatchPickingState.initiate(
        pickingStateArgs,
        { forceRefetch: true, subscribe: false }
      )
    );
  }, [dispatch, pickingStateArgs]);
}
